import { useSelector } from 'react-redux';
import { getRecommendedHublet } from '../store/app/selectors';
export const useRecommendedHublet = () => {
  const recommendedHublet = useSelector(getRecommendedHublet);
  return {
    recommendedHublet
  };
};